import { appStore } from '@/store';
import { features } from '@/lib/features';
import { isExistingAccountEmailLookupEligible } from './isExistingAccountEmailLookupEligible';

export const resolveExistingAccountEmailMessage = (
  isExistingAccount: boolean,
): void => {
  const { ui: uiActions } = appStore.getActions();

  // Google Pay Later use case does not need to suppress signup
  // as it is always forced signup experience
  // For Google Pay Later we set the existing account message
  // to the right value based on the existing account status

  // Member matching Elmos (FEATURE_EXPAND_MEMBER_MATCHING*) are being removed;
  // allocations are fully in control and the feature is deprecated. Keep showing
  // the existing-account email message for US optional and forced signup flows only,
  // matching prior member-match behavior in the one country where it was ramped which is US.
  // Decision made by engineering and product team as a result of https://paypal.atlassian.net/browse/LI-157143
  if (
    features.isActive('isGooglePayLaterOnly') ||
    isExistingAccountEmailLookupEligible()
  ) {
    uiActions.setShowIsExistingAccountEmailMessage(isExistingAccount);
  }
};
